// src/pages/KanbanV2Page.tsx
import { useParams, useSearchParams } from "react-router-dom";
import { useEffect } from "react";
import JiraKanbanView from "../components/views/JiraKanbanView";

export default function KanbanV2Page() {
  const { projectId } = useParams();
  const [searchParams] = useSearchParams();
  const projectIdFromParams = projectId || searchParams.get('projectId');
  const companyIdFromParams = searchParams.get('companyId');

  useEffect(() => {
    document.title = "TaskManager - Kanban";
  }, []);

  return (
    <JiraKanbanView 
      projectId={projectIdFromParams || undefined} 
      companyId={companyIdFromParams || undefined}
    />
  );
}
